import { Component, OnInit, ViewChild } from '@angular/core';
import { OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { AppService } from '../../../app.service';
import { InductionTypes, InductionVM, StateVM } from '../config-setup-inductionand-sections/config-setup-inductionand-sections';
import { IndcutionSearchVM, InductionM } from '../perform-induction/perform-induction';
import { SafetyInductionService } from '../services/safety-induction.service';
import { MatTableDataSource } from '@angular/material/table';

import { DatePipe } from '@angular/common';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { CustomerContactService } from '../../customer-contact/add-new-user-cl/customer-contact.service';
import { FacilitatorOverviewModel } from '../setup-induction-question/setup-induction-question';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-search-induction',
  templateUrl: './search-induction.component.html',
  styleUrls: ['./search-induction.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class SearchInductionComponent implements OnInit {

  constructor(private _appService: AppService, private _inductionService: SafetyInductionService,
    private _contactService: CustomerContactService,) { }

  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  InductionType: number | null = -1;
  StartDate: Date = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
  EndDate: Date = new Date();
  Lname: string;
  Fname: string;
  Email: string;
  Company: string;
  ShowValid: boolean = true;
  ShowInvallid: boolean;
  DataForSearch: InductionVM;
  State: number | null = -1;
  ord: OrdinalDateParse = new OrdinalDateParse();
  SearchResult: IndcutionSearchVM[]
  loading: boolean = false;
  displayedColumns: string[] = ['Date', 'facilitatorName', 'Fname', 'Lname', 'Email', "InductionType", "Company", "IsValid", "State"];

  Facilitator: string
  facilitatorID: number | null = 0
  InputFacilitatorID: number | null = 0
  inductionList: InductionM[]
  ngOnInit() {
    this._appService.setPageTitle('Induction Search');
    // this._appService.setPageSubTitle('');
    this.loading = true

    this._inductionService.SearchInductions().subscribe(res => {
      //console.log("SearchInductions", res)
      if (res.m_Item1) {
        this.DataForSearch = res.m_Item2

        let inductionTypes = this.DataForSearch.InductionTypes
        let states = this.DataForSearch.States


        let type = new InductionTypes();
        type.ID = -1
        type.Title = "All Types";

        let st = new StateVM();
        st.ID = -1;
        st.StateName = "All States"
        st.SideCode = "All States"

        //console.log('states',states)

        //console.log('this.DataForSearch',this.DataForSearch)

        states.unshift(st)
        inductionTypes.unshift(type);

        this.DataForSearch.InductionTypes = inductionTypes
        this.DataForSearch.States = states

        //public InductionTypes: InductionTypes[] 
      }
      this.loading = false
    })

    this.dataSource.sort = this.sort;
    this.OnClickSearch();
    this.GetFacilitator();
    this.GetAllUsersForUser();
  }
  getAllInductions() {
    this._inductionService.GetAllInduction().subscribe(res => {
      this.inductionList = res
    })
  }


  GetFacilitator() {
    this._inductionService.GetFacilitator().subscribe(res => {
      this.Facilitator = res
    })
  }

  facilitatorListSortedNew: FacilitatorOverviewModel[]
  copyfacilitatorListSortedNew: FacilitatorOverviewModel[]

  facilitatiorname: FacilitatorOverviewModel[];
  facilitatorList_: FacilitatorOverviewModel[];
  facilitatorListSorted: FacilitatorOverviewModel[];
  facilitatorList: FacilitatorOverviewModel[];
  facilitatorListfiltered: FacilitatorOverviewModel[];
  showfacilitatorList: boolean = false;
  showFacilitator: boolean = false;
  GetAllUsersForUser() {
    this._contactService.GetAllFacilitatorsForUser().subscribe(res => {
      this.facilitatiorname = res.filter(x => x.FullName == this.Facilitator)
      this.facilitatiorname.map(x => {
        if (x.Access == 'Dealer Group' || x.Access == 'Dealer' || x.Access == 'Support Team') {
          this.facilitatorList_ = res
          //console.log("facilitatorList_",this.facilitatorList_)
          this.showfacilitatorList = true
          this.showFacilitator = false
          this.facilitatorID = this.InputFacilitatorID

          this.facilitatorListSorted = this.facilitatorList_.sort((a, b) => {
            if (a.FullName < b.FullName) { return -1; }
            if (a.FullName > b.FullName) { return 1; }
          })
          let arr = [];
          //console.log("facilitatorListSorted",this.facilitatorListSorted)
          this.inductionList.map(i => {
            this.facilitatorListfiltered = this.facilitatorListSorted.filter(x => x.UserId == i.FacilitatorUserId)
            //console.log("i.FacilitatorUserId",i.FacilitatorUserId)
            arr.push(this.facilitatorListfiltered);

          })
          this.facilitatorList = arr;
          //console.log("facilitatorListtt",this.facilitatorList)
          this.facilitatorListSortedNew = this.facilitatorList.sort((a, b) => {
            if (a[0].FullName < b[0].FullName) { return -1; }
            if (a[0].FullName > b[0].FullName) { return 1; }
          })

          // console.log("facilitatorListSortedNew",this.facilitatorListSortedNew)
          this.copyfacilitatorListSortedNew = this.facilitatorListSortedNew;
        }
        else {
          this.Facilitator = x.FullName
          this.showFacilitator = true
          this.showfacilitatorList = false
          this.facilitatorID = x.UserId
        }
      })
    })
  }

  changeInductionType(ID) {

  }

  StartDateChanged() {
    // console.log("StartDate", this.StartDate)
  }

  EndDateChanged() {
    //console.log("EndDate", this.EndDate)

  }

  changeState(ID) {

  }

  ChangeValid(event) {
    this.ShowValid = event.checked;
  }

  ChangeInvalid(event) {
    this.ShowInvallid = event.checked;
  }

  OnClickReset() {
    this.StartDate = undefined;
    this.EndDate = undefined;

    this.StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
    this.EndDate = new Date();
    this.InductionType = -1;
    this.State = -1;
    this.Fname = "";
    this.Lname = "";
    this.Email = "";
    this.Company = "";
    this.ShowInvallid = null;
    this.ShowValid = true;
    this.SearchResult = []
    this.dataSource.data = [];
    this.facilitaorVal = ""
    this.facilitaorTitle = null;
    this.facilitaorId_ = 0;
    this.InputFacilitatorID = 0;
    this.facilitatorListSortedNew = this.copyfacilitatorListSortedNew

    console.log("facilitaor", this.facilitaorId_, this.facilitaorTitle)
  }
  loadingSearch: boolean = false;
  ShowNodData: boolean = false;
  OnClickSearch() {
    this.loadingSearch = true;
    this.ShowNodData = false;
    let _StartDate = this.StartDate ? this.ord.formatDateOrdinal((this.StartDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false) : this.StartDate;
    let _EndDate = this.EndDate ? this.ord.formatDateOrdinal((this.EndDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false) : this.EndDate;

    let _InductionType = this.InductionType
    if (this.InductionType == -1) {
      _InductionType = null
    }

    let _State = this.State
    if (this.State == -1) {
      _State = null
    }


    if (this.showfacilitatorList == true) {
      this.facilitatorID = this.InputFacilitatorID
    }
    this._inductionService.GetInductionSearch(_StartDate, _EndDate, _InductionType, this.Fname, this.Lname, this.Email, this.Company, this.ShowValid, this.ShowInvallid, _State, this.facilitatorID).subscribe(res => {
      if (res.length == 0 || res == null) {
        this.ShowNodData = true;
      } else {
        this.ShowNodData = false;

      }
      this.loadingSearch = false;

      this.SearchResult = res
      this.dataSource.data = res

    })
  }

  facilitaorTitle: String;
  facilitaorId_: number;
  facilitaorVal: string;
  changeFacilatorAutoComplete(event) {
    this.facilitaorId_ = 0;
    this.InputFacilitatorID = 0;
    const filterValue = event.target.value.toLowerCase();

    this.facilitatorListSortedNew = this.copyfacilitatorListSortedNew.filter(option => option[0].FullName.toLowerCase().includes(filterValue.toString()));

  }


  facilitaorselect(facilitatorid) {
    this.facilitatorListSortedNew.map(x => {
      if (x[0].FullName == facilitatorid) {
        this.facilitaorId_ = x[0].UserId;
        this.InputFacilitatorID = x[0].UserId;
      }
    })
    // this.facilitaorId_ =this.facilitatorListSortedNew.find(f=>f.FullName.toLowerCase() == facilitatorid.toString().toLowerCase()).UserId;
    // this.InputFacilitatorID = this.facilitatorListSortedNew.find(f=>f.FullName == facilitatorid.toString()).UserId;


  }


  columnsOrder: string[] = [
    'Date',
    'facilitatorName',
    'Fname',
    'Lname',
    'Email',
    'InductionType',
    'Company',
    'IsValid',
    'State'

  ];

  customHeaders: { [key: string]: string } = {
    'Fname': 'First Name',
    'Lname': 'Last Name',
    'IsValid': 'Valid',
    'InductionType': 'Induction Type',
    'facilitatorName': 'Facilitator',





  };

  tableData: any[] = this.dataSource.data;
  exportToCsv(): void {
    // Generate the CSV content
    let csvContent = 'data:text/csv;charset=utf-8,';

    // Generate the CSV header
    const header = this.columnsOrder.map(column => this.customHeaders[column] || column);
    csvContent += header.join(',') + '\r\n';

    // Generate the CSV rows
    this.dataSource.data.forEach((row) => {
      const rowData = this.columnsOrder.map(column => {
        const cellData = column === 'IsValid' ? (row[column] ? 'YES' : 'NO') : row[column] || '';
        return this.escapeCsvValue(cellData.toString());
      });
      csvContent += rowData.join(',') + '\r\n';
    });

    // Create a link element to trigger the CSV download
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Search Inductions.csv');
    document.body.appendChild(link);
    link.click();
  }

  escapeCsvValue(value: string): string {
    // Escape double quotes and handle values containing commas or line breaks
    if (value.includes('"')) {
      value = value.replace(/"/g, '""');
    }
    if (value.includes(',') || value.includes('\n') || value.includes('\r')) {
      value = `"${value}"`;
    }
    return value;
  }


  DownloadCSVFile() {
    this.exportToCsv();

  }


}
